import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES, STATUS } from '../lib/constants';
import logoImg from '../assets/logo.png';

export default function Demo() {
    const [currentStatus, setCurrentStatus] = useState('idle');
    const [showNotification, setShowNotification] = useState(false);

    // Simular o fluxo de busca
    const handleStartPickup = () => {
        setCurrentStatus('chegando');
        setShowNotification(true);

        // Simular transição automática dos status
        setTimeout(() => {
            setCurrentStatus('preparando');
        }, 2000);

        setTimeout(() => {
            setCurrentStatus('pronto');
        }, 4500);

        setTimeout(() => {
            setCurrentStatus('entregue');
            setTimeout(() => setShowNotification(false), 3000);
        }, 7000);
    };

    const handleReset = () => {
        setCurrentStatus('idle');
        setShowNotification(false);
    };

    const getStatusInfo = (status) => STATUS[status] || {};

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">

            {/* Header */}
            <header className="container mx-auto px-4 py-6">
                <nav className="flex justify-between items-center">
                    <Link to={ROUTES.HOME} className="flex items-center gap-3">
                        <img src={logoImg} alt="Fila0 Logo" className="h-16 w-auto object-contain" />
                    </Link>
                    <Link to={ROUTES.HOME} className="btn btn-outline">
                        Voltar
                    </Link>
                </nav>
            </header>

            {/* Demo Section */}
            <section className="container mx-auto px-4 py-12">
                <div className="max-w-4xl mx-auto text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-bold text-textPrimary mb-4">
                        Demonstração Interativa
                    </h1>
                    <p className="text-xl text-gray-600">
                        Veja como funciona o fluxo completo de busca. Sem precisar fazer login!
                    </p>
                </div>

                {/* Simulador */}
                <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">

                    {/* Visão do Responsável (PWA) */}
                    <div className="card bg-white border-2 border-gray-200">
                        <div className="bg-primary text-white p-4 -m-6 mb-6 rounded-t-xl">
                            <h2 className="text-xl font-semibold flex items-center gap-2">
                                📱 Tela do Responsável
                            </h2>
                        </div>

                        <div className="space-y-6">
                            {/* Informações do Aluno */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="flex items-center gap-4">
                                    <div className="w-16 h-16 bg-blue-200 rounded-full flex items-center justify-center text-2xl">
                                        👦
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg">João Silva</h3>
                                        <p className="text-gray-600">Turma: 3º Ano A</p>
                                    </div>
                                </div>
                            </div>

                            {/* Botão de Ação */}
                            {currentStatus === 'idle' && (
                                <button
                                    onClick={handleStartPickup}
                                    className="btn btn-success w-full text-lg py-4 animate-pulse"
                                >
                                    🚗 Estou Chegando!
                                </button>
                            )}

                            {/* Status Atual */}
                            {currentStatus !== 'idle' && (
                                <div className={`${getStatusInfo(currentStatus).bgClass} ${getStatusInfo(currentStatus).textClass} p-6 rounded-lg text-center animate-fade-in`}>
                                    <div className="text-5xl mb-3">{getStatusInfo(currentStatus).icon}</div>
                                    <p className="text-2xl font-semibold">{getStatusInfo(currentStatus).label}</p>
                                    {currentStatus === 'preparando' && (
                                        <p className="text-sm mt-2 opacity-75">A escola está preparando o aluno...</p>
                                    )}
                                    {currentStatus === 'pronto' && (
                                        <p className="text-sm mt-2 opacity-75">O aluno está pronto para entrega!</p>
                                    )}
                                    {currentStatus === 'entregue' && (
                                        <p className="text-sm mt-2 opacity-75">Busca concluída com sucesso!</p>
                                    )}
                                </div>
                            )}

                            {/* Botão Reset */}
                            {currentStatus === 'entregue' && (
                                <button
                                    onClick={handleReset}
                                    className="btn btn-outline w-full"
                                >
                                    🔄 Simular Novamente
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Visão da Escola (Dashboard) */}
                    <div className="card bg-white border-2 border-gray-200">
                        <div className="bg-gray-800 text-white p-4 -m-6 mb-6 rounded-t-xl">
                            <h2 className="text-xl font-semibold flex items-center gap-2">
                                🏫 Dashboard da Escola
                            </h2>
                        </div>

                        <div className="space-y-4">
                            <h3 className="font-semibold text-lg mb-4">Buscas em Andamento</h3>

                            {/* Lista de Buscas */}
                            {currentStatus === 'idle' ? (
                                <div className="text-center py-12 text-gray-400">
                                    <div className="text-5xl mb-3">🕐</div>
                                    <p>Nenhuma busca em andamento</p>
                                    <p className="text-sm mt-2">Aguardando notificações...</p>
                                </div>
                            ) : (
                                <div className={`border-2 ${getStatusInfo(currentStatus).borderClass} rounded-lg p-4 animate-slide-up`}>
                                    <div className="flex justify-between items-start mb-3">
                                        <div>
                                            <h4 className="font-semibold">João Silva</h4>
                                            <p className="text-sm text-gray-600">3º Ano A</p>
                                            <p className="text-sm text-gray-600">Responsável: Maria Silva</p>
                                        </div>
                                        <div className={`status-badge ${getStatusInfo(currentStatus).bgClass} ${getStatusInfo(currentStatus).textClass}`}>
                                            {getStatusInfo(currentStatus).icon} {getStatusInfo(currentStatus).label}
                                        </div>
                                    </div>

                                    {/* Ações da Escola */}
                                    {currentStatus === 'chegando' && (
                                        <div className="mt-4 pt-4 border-t">
                                            <button className="btn btn-primary w-full animate-pulse">
                                                ✅ Marcar como "Preparando"
                                            </button>
                                        </div>
                                    )}

                                    {currentStatus === 'preparando' && (
                                        <div className="mt-4 pt-4 border-t">
                                            <button className="btn btn-success w-full animate-pulse">
                                                ✅ Marcar como "Pronto"
                                            </button>
                                        </div>
                                    )}

                                    {currentStatus === 'pronto' && (
                                        <div className="mt-4 pt-4 border-t">
                                            <button className="btn btn-success w-full animate-pulse">
                                                ✅ Marcar como "Entregue"
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Timeline Visual */}
                {currentStatus !== 'idle' && (
                    <div className="max-w-3xl mx-auto mt-12 card bg-gray-50 animate-fade-in">
                        <h3 className="font-semibold text-lg mb-6 text-center">Linha do Tempo</h3>
                        <div className="flex justify-between items-center relative">
                            {/* Linha de progresso */}
                            <div className="absolute top-5 left-0 w-full h-1 bg-gray-300">
                                <div
                                    className="h-full bg-primary transition-all duration-500"
                                    style={{
                                        width:
                                            currentStatus === 'chegando' ? '25%' :
                                                currentStatus === 'preparando' ? '50%' :
                                                    currentStatus === 'pronto' ? '75%' :
                                                        currentStatus === 'entregue' ? '100%' : '0%'
                                    }}
                                />
                            </div>

                            {/* Steps */}
                            {['chegando', 'preparando', 'pronto', 'entregue'].map((status, index) => {
                                const isActive = currentStatus === status;
                                const isPast =
                                    (currentStatus === 'preparando' && index < 1) ||
                                    (currentStatus === 'pronto' && index < 2) ||
                                    (currentStatus === 'entregue' && index < 3);
                                const isCompleted = currentStatus === 'entregue' || isPast;

                                return (
                                    <div key={status} className="flex flex-col items-center relative z-10">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center text-xl transition-all duration-300 ${isActive || isCompleted
                                                ? 'bg-primary text-white scale-110'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            {getStatusInfo(status).icon}
                                        </div>
                                        <p className={`text-xs mt-2 font-medium ${isActive ? 'text-primary' : 'text-gray-600'}`}>
                                            {getStatusInfo(status).label}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Explicação */}
                <div className="max-w-3xl mx-auto mt-12 text-center">
                    <div className="card bg-blue-50">
                        <h3 className="font-semibold text-xl mb-4">💡 Como funciona na prática?</h3>
                        <p className="text-gray-700 leading-relaxed">
                            Esta é uma simulação automática do fluxo real. No sistema completo,
                            <strong> os responsáveis clicam no botão</strong> quando estão chegando, e
                            <strong> a escola atualiza manualmente</strong> cada etapa no dashboard.
                            Tudo acontece em <strong>tempo real</strong> usando Supabase!
                        </p>
                    </div>
                </div>

                {/* CTA */}
                <div className="max-w-2xl mx-auto mt-12 text-center">
                    <Link to={ROUTES.HOME} className="btn btn-primary text-lg px-8 py-4">
                        ← Voltar para Home
                    </Link>
                </div>
            </section>

            {/* Notification Toast */}
            {showNotification && currentStatus === 'chegando' && (
                <div className="fixed bottom-8 right-8 card bg-primary text-white shadow-2xl animate-slide-up max-w-sm">
                    <div className="flex items-center gap-3">
                        <div className="text-3xl">🔔</div>
                        <div>
                            <p className="font-semibold">Nova busca!</p>
                            <p className="text-sm opacity-90">Maria Silva está chegando para buscar João</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
